var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { EventDetailsSuccessActions } from '../types';
export var useOrganizerSpaceMove = function (_a) {
    var event = _a.event, moveEvent = _a.moveEvent, onSuccess = _a.onSuccess, onError = _a.onError, onClose = _a.onClose;
    var t = useTranslation('meetingRooms').t;
    /** Resolves true when the move was accepted (the panel is closing). */
    var moveOrganizerSpace = useCallback(function (toSpace, notifyAttendees) { return __awaiter(void 0, void 0, void 0, function () {
        var organizer, fromSpaceId, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!event) {
                        return [2 /*return*/, false];
                    }
                    organizer = event.space_invitees.find(function (spaceInvitee) { return spaceInvitee.is_organizer; });
                    fromSpaceId = organizer === null || organizer === void 0 ? void 0 : organizer.space_id;
                    if (!fromSpaceId || fromSpaceId === toSpace.id) {
                        return [2 /*return*/, false];
                    }
                    return [4 /*yield*/, moveEvent({
                            eventId: event.id,
                            oldSpaceId: fromSpaceId,
                            newSpaceId: toSpace.id,
                            // A details move changes only the room; the times sent are the
                            // event's own.
                            startTime: event.start.date_time,
                            endTime: event.end.date_time,
                            timezone: event.start.time_zone,
                            notifyAttendees: notifyAttendees,
                        })];
                case 1:
                    result = _a.sent();
                    if (result === 'aborted') {
                        return [2 /*return*/, false];
                    }
                    if (result === 'failed') {
                        onError(new Error(t('errors.failed_to_change_room', { name: toSpace.name })));
                        return [2 /*return*/, false];
                    }
                    // The 202 commits the move. Notify hosts — grids key their
                    // move_out/create sync polling and toast off this. Guarded: the
                    // bridge dispatches subscribers synchronously without isolation, and
                    // a throwing host subscriber must not block the close below.
                    try {
                        onSuccess(EventDetailsSuccessActions.MOVED_ORGANIZER_SPACE, {
                            organizerMove: { fromSpaceId: fromSpaceId, toSpaceId: toSpace.id },
                        });
                    }
                    catch (_b) {
                        // Host-side feedback failed; the move itself is committed.
                    }
                    onClose();
                    return [2 /*return*/, true];
            }
        });
    }); }, [event, moveEvent, onSuccess, onError, onClose, t]);
    return { moveOrganizerSpace: moveOrganizerSpace };
};
